import {ValidateResultProps, ValidateState} from 'lib.common';
import {Property} from 'csstype';
import {DateViews, TimeViews} from './constants';
import {UsePtrnEstMstrDet_UpdateCampoFn} from './hooks/usePtrnMaestroDetalleEstado/usePtrnEstadoMaestroDetalleTypes';
import React from 'react';

//#region externos
export type {
   RenderRowFn,
   GetRowIdFn,
   RenderLastRowFn
} from './components/PtrnTablaBase/PtrnTablaBaseTypes';
export type {CampoEditableEventHandlerBase} from './components/CampoEditable/campoEditableTypes';
export type {PtrnStep, PtrnStepperRef} from './components/PtrnStepper/PtrnStepperTypes';
export type {LeyendaItem, LeyendaValue} from './components/LeyendaItemList/LeyendaItemListTypes';
export type {
   SpreadSheetColConfig,
   SpreadSheetColHeaderCfg,
   SpreadSheetRenderRowFn
} from '../moleculas/SpreadSheetStyledTable/SpreadSheetStyledTableTypes';
export type {UsePtrnEstadoResult} from './hooks/usePtrnEstadoSimple/usePtrnEstadoSimpleTypes';
export type {PtrnConfigAgrupar} from './components/PtrnTablaGrupos';
export type {
   PtrnMaestroDetalleConfig,
   UsePtrnEstMstrDet_SetErrorMultiCampoFn
} from './hooks/usePtrnMaestroDetalleEstado/usePtrnEstadoMaestroDetalleTypes';
export type {PtrnMaestroDetalleTabsRef} from './PtrnMaestroDetalleTabs/PtrnMaestroDetalleTabsTypes';
export type {
   RdcrMstrDetAccionAddDetParams,
   RdcrMstrDetAccionSetErrorCampoParams,
   RdcrMstrDetAccionUpdtCampoParams
} from './hooks/usePtrnMaestroDetalleEstado/useRdcrMstrDet';

//#endregion

//#region personalizacion
export interface PtrnCampoDistribucionGrid {
   xs: number;
   sm?: number;
   md?: number;
   lg?: number;
   xl?: number;
}
export interface PtrnCampoDistribucionTabla {
   width: number | string;
}
export enum PtrnIcons {
   search = 'search',
   delete = 'delete',
   insert = 'insert',
   update = 'update',
   check = 'check',
   uncheck = 'uncheck',
   cancel = 'cancel',
   edit = 'edit',
   excel = 'excel',
   pdf = 'pdf',
   txt = 'txt',
   warning = 'warning',
   error = 'error',
   success = 'success',
   add = 'plus',
   diff = 'minus',
   show = 'show',
   formula = 'formula',
   formulaLetraA = 'formulaLetraA',
   stop1 = 'stop1',
   stop2 = 'stop2',
   info = 'info',
   mic = 'mic',
   taskAltIcon = 'taskAltIcon'
}
export enum PtrnColors {
   default = 'inherit',
   error = 'error',
   warning = 'warning',
   success = 'success',
   info = 'info',
   primary = 'primary',
   secondary = 'secondary'
}
export enum PtrnSize {
   small = 'small',
   medium = 'medium',
   large = 'large'
}
export enum PtrnColorsSubAttr {
   contrastText = 'contrastText',
   dark = 'dark',
   light = 'light',
   main = 'main'
}
export enum PtrnTipoAccion {
   positiva = 'positiva',
   neutra = 'neutra',
   negativa = 'negativa',
   opcional = 'opcional'
}
//#endregion
//#region comunes
export interface ConFormula<T = any> {
   valor: T;
   valorVisible: string;
   formula: string;
}
export type PtrnDataInput = ObjectStrKeys | PtrnState;
export type PtrnDataEntidad = PtrnDataInput;
export type PtrnValor_o_Fn<T> = [T] extends [any]
   ? T | ((param?: PtrnAccionPametroAuxiliar) => T)
   : never;

export type ObjectStrKeys = {[key: string]: any};
export interface PtrnStateValue<T = any> {
   valor: T;
   errores: string[] | null;
   fueModificado?: boolean;
}
export interface PtrnState {
   [k: string]: PtrnStateValue;
}
export interface PtrnAccionesInternas {
   closeForm?: () => void;
   setForm?: React.Dispatch<React.SetStateAction<any>>;
   setMDState?: UsePtrnEstMstrDet_UpdateCampoFn;
   //TODO
   finishSearch?: () => void;
}
//#endregion
//#region acciones genericas
export enum PtrnBotonPosicion {
   inicio = 'inicio',
   fin = 'fin'
}
export interface PtrnAccionPametroAuxiliar {
   ptrnRef?: PtrnAccionesInternas | null;
   camposData?: PtrnDataInput;
   index?: number;
   campoConfig?: PtrnCampoEditable | PtrnCampoLectura;
   componenteRef?: React.Ref<any>;
   ruta?: string[];
   idAux?: string;
}

export type PtrnProcesarData<R> = (data: any, auxParam?: PtrnAccionPametroAuxiliar) => R;

export enum PtrnAccionEstado {
   error = 'error',
   warning = 'warning',
   success = 'success',
   default = 'default'
}
export interface PtrnAccionResultado {
   estado: PtrnAccionEstado;
   mensaje?: string;
}
export type PtrnAccionFn = (data?: PtrnDataInput, auxParam?: PtrnAccionPametroAuxiliar) => void;
export type PtrnAccionFnData = (
   data: PtrnDataInput,
   auxParam?: PtrnAccionPametroAuxiliar
) => void | Promise<void>;

export type PtrnAccionFnRetorno<T = any> = (
   data: PtrnDataInput,
   auxParam?: PtrnAccionPametroAuxiliar
) => T;
export interface PtrnAccion {
   label: string;
   fn: PtrnAccionFn | PtrnAccionFnData | PtrnAccionFnRetorno;
   icon?: PtrnIcons;
   tipo?: PtrnTipoAccion;
   descripcion?: string;
   msgConfirmacion?: string | null;
   oculto?: PtrnValor_o_Fn<boolean>;
   size?: PtrnSize;
}
export interface PtrnAccionesAdicionales {
   positivas?: PtrnAccion[];
   negativas?: PtrnAccion[];
   neutras?: PtrnAccion[];
}
export interface PtrnAccionSearch extends PtrnAccion {
   label: 'Buscar';
   icon: PtrnIcons.search;
   fn: PtrnAccionFnData;
}
export interface PtrnAccionDelete extends PtrnAccion {
   label: 'Eliminar';
   icon: PtrnIcons.delete;
   fn: PtrnAccionFnData;
}
export interface PtrnAccionInsert extends PtrnAccion {
   label: 'Guardar';
   icon: PtrnIcons.insert;
   fn: PtrnAccionFnData;
}
export interface PtrnAccionUpdate extends PtrnAccion {
   label: 'Guardar';
   icon: PtrnIcons.update;
   fn: PtrnAccionFnData;
}
export interface PtrnAccionCancel extends PtrnAccion {
   label: 'Cancelar';
   fn: PtrnAccionFn;
}
//#endregion

//#region campo base
export enum PtrnTiposCampo {
   string = 'string',
   int = 'int',
   float = 'float',
   date = 'date',
   time = 'time',
   datetime = 'datetime',
   switch = 'switch',
   checkbox = 'checkbox',
   select = 'select',
   radio = 'radio',
   selectCheckbox = 'selectCheckbox',
   formula = 'formula',
   //tipos especiales
   tabgroup = 'tabgroup',
   tab = 'tab',
   grupo = 'grupo',
   calculado = 'calculado',
   boton = 'boton'
}
export type PtrnTipoCampo = PtrnTiposCampo;

export interface PtrnCampoBase {
   tipo: PtrnTiposCampo;
   name: string;
   defaultValue?: any;
   label?: string;
   esId?: boolean;
   esObligatorio?: boolean | ptrnCondicionFn;
   alinear?: PtrnAlineacion;
   enTabla?: {
      width?: number | string;
      headers?: {
         colSpan?: number;
         rowSpan?: number;
         label?: string | React.ReactElement;
         width?: string | number;
      }[];
   };
   //soporte contenedores de configuracion q usan tanto lectura como editable
   soloLectura?: boolean | ptrnSoloLecturaCampo;
   nullValue?: string;
}
export type ptrnCondicionFn = (nuevoValorCampo: any, camposData?: PtrnDataInput) => boolean;
export type ptrnOcultarCampoFn = ptrnCondicionFn;

export type ptrnDeshabilitarCampoFn = ptrnCondicionFn;
export type ptrnSoloLecturaCampo = ptrnCondicionFn;

export type ptrnEditableCampoFn = ptrnCondicionFn;
export interface PtrnCampoGeneralBoton extends PtrnCampoEditableBase, PtrnCampoLecturaBase {
   tipo: PtrnTiposCampo.boton;
   tipoAccion?: PtrnValor_o_Fn<PtrnTipoAccion>;
   onClick: PtrnAccionFnData;
   color?: PtrnValor_o_Fn<PtrnColors>;
   generarValorMostrar?: PtrnCampoLecturaFnGenValorMostrar;
   icon?: PtrnIcons;
   posicionIcono?: PtrnBotonPosicion;
   usarEnFiltrar?: false;
   ocultoEditable?: boolean | ptrnOcultarCampoFn;
   disabled?: boolean | ptrnDeshabilitarCampoFn;
   ocultoLectura?: boolean | ptrnOcultarCampoFn;
   alinear?: PtrnAlineacion;
   size?: PtrnSize;
   noBorder?: boolean;
   title?: PtrnValor_o_Fn<string>;
}
//#endregion

//#region campo editable
export type PtrnCamposEditablesConfigObject = {[key: string]: PtrnCampoBase};
export type PtrnCampoEditableAccionFn = (
   campoValor: any,
   auxParam?: PtrnAccionPametroAuxiliar
) => void;
export interface PtrnCampoEditableAcciones {
   onClickSearch?: PtrnCampoEditableAccionFn;
}
export interface PtrnCampoValidarResult {
   errores: ValidateResultProps[];
   gravedadMaxima: ValidateState;
}
export interface PtrnResultadoProcesarCampo {
   valorProcesado: PtrnStateValue;
   gravedadMaxima: ValidateState;
}
export type ptrnValidarCampoEditableFn = (
   nuevoValorCampo: any,
   camposData?: PtrnState,
   globalState?: any
) => PtrnCampoValidarResult | Promise<PtrnCampoValidarResult>;
export type ptrnTransformarFn<T = any> = (nuevoValorCampo: T, camposData?: PtrnState) => T;

export type ptrnValidarEstadoFn = (opts?: {
   estadosValidar?: (string | PtrnCampoEditableBase)[];
   validacionAdicional?: ptrnValidarCampoEditableFn;
   procesarResultadoValidacion?: (resultadoValidacion: PtrnCampoValidarResult) => void;
}) => void | Promise<void>;

export type ptrnValidarEstadoExFn = (opts?: {
   state: PtrnState;
   globalState?: any;
   cfgState: PtrnCamposEditablesConfigObject;
   onProcesarValidarCampoResult: (
      nombreCampo: string,
      validarCampoResult: PtrnResultadoProcesarCampo
   ) => void | Promise<void>;
   camposEspecificos?: string[];
   ignorarCampos?: string[];
}) => ValidateState | Promise<ValidateState>;

export interface PtrnCampoEditableBase extends PtrnCampoBase, PtrnCampoEditableAcciones {
   noBorder?: boolean;
   ocultoEditable?: boolean | ptrnOcultarCampoFn;
   distribucionEditable?: PtrnCampoDistribucionGrid;
   disabled?: boolean | ptrnDeshabilitarCampoFn;
   validarOnChange?: ptrnValidarCampoEditableFn;
   validarOnBlur?: ptrnValidarCampoEditableFn;
   transformarAntesDeValidar?: ptrnTransformarFn;
   afterOnChange?: PtrnAccionFnData;
}
export interface PtrnCampoEditableString extends PtrnCampoEditableBase {
   tipo: PtrnTiposCampo.string;
   maxLength?: number;
   mayus?: boolean;
   minus?: boolean;
   alinearTexto?: Property.TextAlign;
   ignorarCaracteres?: string[] | RegExp;
   esPassword?: boolean;
   seleccionarTodo?: boolean;
}
export interface PtrnCampoEditableInt extends PtrnCampoEditableBase {
   tipo: PtrnTiposCampo.int;
   alinearTexto?: Property.TextAlign;
   max?: number;
   min?: number;
   permitirNegativos?: boolean;
   seleccionarTodo?: boolean;
   prefix?: string;
}
export interface PtrnCampoEditableFloat extends PtrnCampoEditableBase {
   tipo: PtrnTiposCampo.float;
   alinearTexto?: Property.TextAlign;
   max?: number;
   min?: number;
   maxDigitosEnteros?: number;
   maxDigitosDecimales?: number;
   permitirNegativos?: boolean;
}
//TODO separar tipado interno en comun
export interface PtrnCampoEditableFormula extends PtrnCampoEditableBase {
   tipo: PtrnTiposCampo.formula;
   generarValorMostrar?: PtrnCampoEditableFnObjetoToStr;
   onCopyFormulaRef?: (formulaRef: string) => void;
   mostrarCopiarReferencia?: boolean;
   formulaRef?: string;
   mostrarFormulaOnBlur?: boolean;
   alinearTexto?: Property.TextAlign;
}
export interface PtrnCampoEditableDatetime extends PtrnCampoEditableBase {
   tipo: PtrnTiposCampo.date | PtrnTiposCampo.datetime;
   maxDate?: Date; // 14:00
   minDate?: Date; //
   disableHighlightToday?: boolean;
   disableWeekends?: boolean;
   disabledDays?: number[];
   excludeDates?: Date[];
   views?: (DateViews.day | DateViews.month | DateViews.year)[];
   esFormatoPeriodo?: boolean;
}
export interface PtrnCampoEditableTime extends PtrnCampoEditableBase {
   tipo: PtrnTiposCampo.time;
   maxTime?: Date;
   minTime?: Date;
   minutesStep?: number;
   views?: Array<TimeViews.hours | TimeViews.minutes | TimeViews.seconds>;
}
export interface PtrnCampoEditableBoolean extends PtrnCampoEditableBase {
   tipo: PtrnTiposCampo.switch | PtrnTiposCampo.checkbox;
   color?: PtrnColors;
   noPadding?: boolean;
}
export type PtrnCampoEditableFnObjetoToStr = (
   campoValor: any,
   auxParam?: PtrnAccionPametroAuxiliar
) => string;
export interface PtrnCampoEditableArray extends PtrnCampoEditableBase {
   tipo: PtrnTiposCampo.select | PtrnTiposCampo.radio;
   array: any[];
   row?: boolean; //solo para Radio
   emptyMessage: string;
   generarValorMostrar?: PtrnCampoEditableFnObjetoToStr;
   generarDenominacionMostrar?: PtrnCampoEditableFnObjetoToStr;
   onCargarPrimerLote?: PtrnAccionFn;
   onCargarSiguienteLote?: PtrnAccionFn;
   isOptionEqualToValue?: (option: unknown, value: unknown) => boolean;
   filterOptions?: (
      options: unknown,
      inputValue: string,
      naturalSearch?: (option: unknown, input: string) => boolean
   ) => boolean;
   prioridades?: string[];
   defaultValueFilter?: (option: unknown, defaultValue: unknown) => boolean;
   noBorder?: boolean;
   disableClearable?: boolean;
   externalFilter?: PtrnProcesarData<boolean>;
   asignarPrimerValorSiNull?: boolean;
   emptyAction?: (inputValue: string, auxParam?: PtrnAccionPametroAuxiliar) => void;
   labelEmptyAction?: (inputValue: string) => string;
   popperWidth?: string | number;
   popperAlignRight?: boolean;
   activeModeEllipsis?: boolean;
}
export interface PtrnCampoEditableSelectCheckBox extends PtrnCampoEditableBase {
   tipo: PtrnTiposCampo.selectCheckbox;
   array: any[];
   emptyMessage: string;
   esIndividual: boolean;
   maxVisibleChips: number; //nro maximo de items visible
   formatMaxVisibleMessage: PtrnCampoEditableFnObjetoToStr; //genera mensaje pasado el maximo nro de elementos;
   generarValorMostrar?: PtrnCampoEditableFnObjetoToStr;
   generarDenominacionMostrar?: PtrnCampoEditableFnObjetoToStr;
   onCargarPrimerLote?: PtrnAccionFn;
   onCargarSiguienteLote?: PtrnAccionFn;
   noBorder?: boolean;
   disableClearable?: boolean;
   externalFilter?: PtrnProcesarData<boolean>;
   asignarPrimerValorSiNull?: boolean;
   asignarPrimerValorTodos?: boolean;
}
export type PtrnListaCamposType = PtrnCampoBase[] | [PtrnCampoBase, ...PtrnCampoBase[]];
export interface PtrnCampoEditableGrupo<C extends PtrnListaCamposType = PtrnCampoEditable[]>
   extends PtrnCampoEditableBase {
   tipo: PtrnTiposCampo.grupo;
   campos: C;
   fullWidth?: boolean;
   hideBorder?: boolean;
}
export interface PtrnCampoEditableTab<C extends PtrnListaCamposType = PtrnCampoEditable[]>
   extends PtrnCampoEditableBase {
   tipo: PtrnTiposCampo.tab;
   campos: C;
}
//TODO convertir a generico para mejorar tipado donde se usen tabs
//export type PtrnListaTabsType = PtrnCampoBase[] | [PtrnCampoBase, ...PtrnCampoBase[]];
export interface PtrnCampoEditableGrupoTab extends PtrnCampoEditableBase {
   tipo: PtrnTiposCampo.tabgroup;
   alineacionTabs: PtrnAlineacion;
   tabList: PtrnCampoEditableTab[];
}
export interface PtrnCampoEditableCalculado extends PtrnCampoEditableBase {
   tipo: PtrnTiposCampo.calculado;
   generarValorMostrar?: PtrnCampoEditableFnObjetoToStr;
}
//#endregion

//#region campo lectura
export type PtrnCampoLecturaFnGenValorMostrar = (
   valorCampo?: any,
   auxParam?: {
      camposData?: PtrnDataInput;
      index?: number;
      campoConfig?: PtrnCampoLectura;
      ptrnRef?: PtrnAccionesInternas | null;
      ruta?: string[];
   }
) => string;

export enum PtrnAlineacion {
   center = 'center',
   inherit = 'inherit',
   justify = 'justify',
   left = 'left',
   right = 'right'
}
export interface PtrnCampoLecturaBase extends PtrnCampoBase {
   nullValue?: string;
   ocultoLectura?: boolean | ptrnOcultarCampoFn;
   distribucionLectura?: PtrnCampoDistribucionGrid;
   generarValorMostrar?: PtrnCampoLecturaFnGenValorMostrar;
   usarEnOrdenar?: boolean;
   usarEnFiltrar?: boolean;
}
export interface PtrnCampoLecturaObjeto extends PtrnCampoLecturaBase {
   tipo:
      | PtrnTiposCampo.calculado
      | PtrnTiposCampo.radio
      | PtrnTiposCampo.select
      | PtrnTiposCampo.selectCheckbox;
   generarValorMostrar: PtrnCampoLecturaFnGenValorMostrar;
}
export interface PtrnCampoLecturaFloat extends PtrnCampoLecturaBase {
   tipo: PtrnTiposCampo.float;
   maxDigitosDecimales?: number;
}
export interface PtrnCampoLecturaDateTime extends PtrnCampoLecturaBase {
   tipo: PtrnTiposCampo.datetime | PtrnTiposCampo.date;
}
export interface PtrnCampoLecturaTime extends PtrnCampoLecturaBase {
   tipo: PtrnTiposCampo.time;
}
export interface PtrnCampoLecturaGrupo extends PtrnCampoLecturaBase {
   tipo: PtrnTiposCampo.grupo | PtrnTiposCampo.tab | PtrnTiposCampo.tabgroup;
   campos?: PtrnCampoEditable[];
   tabList?: PtrnCampoEditableTab[];
}

//#endregion
//#region centralizadores
export type PtrnCampoEditable =
   | PtrnCampoEditableString
   | PtrnCampoEditableInt
   | PtrnCampoEditableFloat
   | PtrnCampoEditableDatetime
   | PtrnCampoEditableTime
   | PtrnCampoEditableBoolean
   | PtrnCampoEditableArray
   | PtrnCampoEditableGrupo
   | PtrnCampoEditableTab
   | PtrnCampoEditableGrupoTab
   | PtrnCampoEditableCalculado
   | PtrnCampoEditableSelectCheckBox
   | PtrnCampoGeneralBoton
   | PtrnCampoEditableFormula;
export type PtrnCampoLectura =
   | PtrnCampoLecturaBase
   | PtrnCampoLecturaFloat
   | PtrnCampoLecturaObjeto
   | PtrnCampoLecturaGrupo
   | PtrnCampoLecturaDateTime
   | PtrnCampoLecturaTime
   | PtrnCampoGeneralBoton;
//#endregion

//#region tipos utilitarios
export type ExtractPrimitiveFromPtrnEditable<T> = T extends PtrnCampoEditableString
   ? string
   : T extends PtrnCampoEditableInt
   ? number
   : T extends PtrnCampoEditableFloat
   ? number
   : T extends PtrnCampoEditableDatetime
   ? Date
   : T extends PtrnCampoEditableTime
   ? Date
   : T extends PtrnCampoEditableBoolean
   ? boolean
   : T extends PtrnCampoEditableArray
   ? any
   : T extends PtrnCampoEditableGrupo
   ? any
   : T extends PtrnCampoEditableTab
   ? any
   : T extends PtrnCampoEditableGrupoTab
   ? any
   : T extends PtrnCampoEditableCalculado
   ? string
   : T extends PtrnCampoEditableSelectCheckBox
   ? any
   : T extends PtrnCampoGeneralBoton
   ? any
   : T extends PtrnCampoEditableFormula
   ? ConFormula<number | string>
   : never;

export type DeepPartial<T> = {
   [P in keyof T]?: T[P] extends object
      ? T[P] extends Function
         ? T[P] // preservar funcionas sin hacerlas parcial
         : DeepPartial<T[P]> // aplicar a objetos anidados
      : T[P]; // si la propiedad no es objeto mantener
};
//#endregion
//#region TODO ptrn campo v2
// modificar todo patrones a uso de v2
/* export type PtrnCampoGenerarValorMostrarFn = (
   valorCampo?: any,
   auxParam?: {
      camposData?: PtrnDataInput;
      index?: number;
      campoConfig?: PtrnCampoBase;
      ptrnRef?: PtrnAccionesInternas | null;
   }
) => string;

export interface PtrnCampoConfiguracionBase {
   oculto?: boolean | fnPtrnOcultarCampo;
   distribucion?: PtrnCampoDistribucionGrid;
   generarValorMostrar?: PtrnCampoGenerarValorMostrarFn;
}
export interface PtrnCampoConfiguracionEditable {}
export interface PtrnCampoConfiguracionLectura {}
export interface PtrnCampoConfiguracionTabla {
   alinear?: PtrnAlineacion;
   width?: number | string;
   usarEnOrdenar?: boolean;
   usarEnFiltrar?: boolean;
}
export interface PtrnCampoConfiguracion {
   tipo: PtrnTiposCampo;
   name: string;
   defaultValue?: any;
   nullValue?: string;
   label?: string;
   esId?: boolean;
   esEditable?: boolean | fnPtrnEditableCampo;
   enTabla?: PtrnCampoConfiguracionTabla;
   editable?: PtrnCampoConfiguracionEditable & PtrnCampoConfiguracionBase;
   lectura?: PtrnCampoConfiguracionLectura & PtrnCampoConfiguracionBase;
}
 */
//#endregion
